export const extractOnlyStripeVendor = (vendors) => {
    const usables = vendors.filter(vendor => vendor.settingTarget === true);
    // 利用可能なベンダーが複数ある場合は何もしない
    if (usables.length > 1) {
        return undefined;
    }
    // Stripeの接続設定を取得
    return usables.find(usable => usable.storeType === 'STRIPE');
};
export const extractOnlyUnivapayVendor = (vendors) => {
    const usables = vendors.filter(vendor => vendor.settingTarget === true);
    // 利用可能なベンダーが複数ある場合は何もしない
    if (usables.length > 1) {
        return undefined;
    }
    // UPCの接続設定を取得
    return usables.find(usable => usable.storeType === 'UPC');
};
